<template>
	<nuxt-link
		:id="article.uuid"
		:to="'/' + article.full_slug"
		:aria-label="article.content.title"
		class="flex-y relative"
	>
		<!-- Badge -->
		<span v-if="showRecommendationBadge" :title="t('recommended')">
			<v-icon
				icon="star"
				class="absolute top-2 right-2 fill-[#f6ca6c] stroke-white text-xl md:text-4xl"
				:title="t('recommended')"
			/>
		</span>

		<nuxt-picture
			v-if="article.content.image?.filename"
			:src="article.content.image.filename"
			:alt="article.content.image?.alt ?? article.content.title"
			class="w-full"
			loading="lazy"
			provider="storyblok"
			sizes="xs:100vw sm:640px md:768px lg:1024px xl:1280px 2xl:1536px"
			:img-attrs="{
				class: 'rounded-2xs object-cover w-full h-[6.5rem] lg:h-[14rem]',
			}"
		/>

		<div class="mt-3">
			<v-h6 tag="h2" class="text-lg! leading-5 md:text-xl!">
				{{ article.content.title }}
			</v-h6>

			<div
				v-if="article.content.ingress"
				class="mt-1 line-clamp-3 text-gray-750"
			>
				<sb-rich-text
					:document="article.content.ingress"
					class="**:leading-tight **:lg:leading-snug"
				/>
			</div>
		</div>
	</nuxt-link>
</template>

<script setup lang="ts">
import type {ISbStoryData} from "storyblok-js-client";

withDefaults(
	defineProps<{
		article: ISbStoryData;
		showRecommendationBadge?: boolean;
	}>(),
	{
		showRecommendationBadge: false,
	},
);

const {t} = useI18n();
</script>

<i18n lang="json">
{
	"et": {
		"recommended": "Soovitatud artikkel!"
	},
	"fi": {
		"recommended": "Suositeltu artikkeli!"
	}
}
</i18n>
